/* eslint-disable no-param-reassign */
import 'semantic-ui-css/semantic.min.css';
import 'isomorphic-fetch';
import '@babel/polyfill';

import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { render } from 'react-dom';

import loggerMiddleware from '../r/shared/middleware/logger';
import { registerSW } from '../r/components/form/utils';
import FormBase from '../r/components/form';
import rootReducer from '../r/rootReducer';

const Root = ({ store }) => (
  <Provider store={store}>
    <FormBase />
  </Provider>
);

const preloadedState = {};
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggerMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState,
});

render(<Root store={store} />, document.getElementById('fplsFormBase'));
registerSW();